import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
const baseStyle = {
    display: "flex",
    alignItems: "center",
    gap: "var(--hydrax-space-sm)",
    padding: "var(--hydrax-space-sm) var(--hydrax-space-md)",
    borderRadius: "var(--hydrax-radius-sm)",
    color: "var(--hydrax-color-text-muted)",
    fontFamily: "var(--hydrax-font-sans)",
    fontSize: "var(--hydrax-type-body-size)",
    lineHeight: "var(--hydrax-type-body-line-height)",
    textDecoration: "none",
    cursor: "pointer",
    transition: "background var(--hydrax-motion-fast) var(--hydrax-ease-out), color var(--hydrax-motion-fast) var(--hydrax-ease-out)",
};
const activeStyle = {
    background: "var(--hydrax-color-bg-raised)",
    color: "var(--hydrax-color-text-strong)",
};
export function NavItem({ icon, label, active = false, badge, href, onClick, linkComponent, }) {
    const content = (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: icon, label: label, size: 16 }), _jsx("span", { style: { flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }, children: label }), badge ? (_jsx("span", { style: {
                    fontFamily: "var(--hydrax-font-mono)",
                    fontSize: "11px",
                    color: "var(--hydrax-color-text-muted)",
                    padding: "2px 6px",
                    borderRadius: "var(--hydrax-radius-sm)",
                    background: "var(--hydrax-color-surface)",
                    border: "1px solid var(--hydrax-color-border)",
                }, children: badge })) : null] }));
    const style = active ? { ...baseStyle, ...activeStyle } : baseStyle;
    const ariaCurrent = active ? "page" : undefined;
    if (href) {
        if (linkComponent) {
            const LinkComponent = linkComponent;
            return (_jsx(LinkComponent, { to: href, style: style, onClick: onClick, "aria-current": ariaCurrent, children: content }));
        }
        return (_jsx("a", { href: href, style: style, onClick: onClick, "aria-current": ariaCurrent, children: content }));
    }
    return (_jsx("button", { type: "button", onClick: onClick, style: { ...style, border: "none", textAlign: "left", width: "100%" }, "aria-current": ariaCurrent, children: content }));
}
//# sourceMappingURL=NavItem.js.map